import React from 'react';
import { IExerciseInstance } from '../../../types/workout/exercise-instance';
import { PD, SFm } from './tokens';
import { nonEmpty } from './helpers';

interface PrescriptionChipsProps {
  exercise: IExerciseInstance;
}

const PrescriptionChips: React.FC<PrescriptionChipsProps> = ({ exercise }) => {
  const bits: string[] = [];
  if (nonEmpty(exercise.sets) && nonEmpty(exercise.repetitions)) {
    bits.push(`${exercise.sets} × ${exercise.repetitions}`);
  } else if (nonEmpty(exercise.sets)) {
    bits.push(`${exercise.sets} sets`);
  } else if (nonEmpty(exercise.repetitions)) {
    bits.push(`${exercise.repetitions} reps`);
  }
  if (nonEmpty(exercise.weight)) bits.push(`${exercise.weight} kg`);
  if (nonEmpty(exercise.time)) bits.push(`${exercise.time}s`);
  if (nonEmpty(exercise.tempo)) bits.push(`tempo ${exercise.tempo}`);
  if (nonEmpty(exercise.restInterval)) bits.push(`rest ${exercise.restInterval}s`);
  if (nonEmpty(exercise.distance)) bits.push(`${exercise.distance}m`);
  if (nonEmpty(exercise.duration)) bits.push(`${exercise.duration}s`);
  if (nonEmpty(exercise.difficulty)) bits.push(`dif ${exercise.difficulty}`);

  if (bits.length === 0) return null;

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
      {bits.map((b, i) => (
        <span
          key={i}
          style={{
            padding: '3px 8px',
            borderRadius: 999,
            background: PD.fill,
            fontFamily: SFm,
            fontSize: 11,
            fontWeight: 500,
            color: PD.ink2
          }}
        >
          {b}
        </span>
      ))}
    </div>
  );
};

export default PrescriptionChips;
